import api from './api';
import { API_ROUTES } from '@/lib/constants';
import { createCrudService } from './crud.factory';
import type { Agreement, AgreementTemplate, ApiResponse } from '@/types/table';

export const agreementService = {
  ...createCrudService<Agreement>(API_ROUTES.AGREEMENTS),

  send:          async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/send`)).data,
  markSigned:    async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/mark-signed`)).data,
  markActive:    async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/mark-active`)).data,
  markCompleted: async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/mark-completed`)).data,
  cancel:        async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/cancel`)).data,
  duplicate:     async (id: string): Promise<ApiResponse<Agreement>> => (await api.post(`${API_ROUTES.AGREEMENTS}/${id}/duplicate`)).data,

  downloadPdf: async (id: string): Promise<Blob> => {
    const response = await api.get(`${API_ROUTES.AGREEMENTS}/${id}/pdf`, { responseType: 'blob' });
    return response.data;
  },

  getNextNumber: async (): Promise<ApiResponse<{ nextNumber: string }>> => {
    const response = await api.get(`${API_ROUTES.AGREEMENTS}/next-number`);
    return response.data;
  },
};

export const agreementTemplateService = {
  list: async (params?: { kind?: string; includeInactive?: boolean }): Promise<ApiResponse<AgreementTemplate[]>> => {
    const response = await api.get(API_ROUTES.AGREEMENT_TEMPLATES, {
      params: params?.includeInactive ? { ...params, includeInactive: 'true' } : params,
    });
    return response.data;
  },

  get: async (id: string): Promise<ApiResponse<AgreementTemplate>> => {
    const response = await api.get(`${API_ROUTES.AGREEMENT_TEMPLATES}/${id}`);
    return response.data;
  },

  create: async (data: Partial<AgreementTemplate>): Promise<ApiResponse<AgreementTemplate>> => {
    const response = await api.post(API_ROUTES.AGREEMENT_TEMPLATES, data);
    return response.data;
  },

  update: async (id: string, data: Partial<AgreementTemplate>): Promise<ApiResponse<AgreementTemplate>> => {
    const response = await api.patch(`${API_ROUTES.AGREEMENT_TEMPLATES}/${id}`, data);
    return response.data;
  },

  remove: async (id: string): Promise<ApiResponse<AgreementTemplate>> => {
    const response = await api.delete(`${API_ROUTES.AGREEMENT_TEMPLATES}/${id}`);
    return response.data;
  },

  clone: async (id: string, name?: string): Promise<ApiResponse<AgreementTemplate>> => {
    const response = await api.post(`${API_ROUTES.AGREEMENT_TEMPLATES}/${id}/clone`, name ? { name } : {});
    return response.data;
  },
};
